export const BlueprintGrid = ({ className = "" }) => (
    <div
        aria-hidden="true"
        className={`blueprint-bg blueprint-fade pointer-events-none absolute inset-0 ${className}`}
    >
        <span className="absolute left-1/2 top-0 h-full w-px bg-white/[0.04]" />
        <span className="absolute left-0 top-1/2 h-px w-full bg-white/[0.04]" />
    </div>
);

export const CrossMarker = ({ className = "" }) => (
    <svg
        aria-hidden="true"
        viewBox="0 0 16 16"
        className={`h-4 w-4 ${className}`}
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
    >
        <path d="M8 0v16M0 8h16" />
        <circle cx="8" cy="8" r="2.4" fill="none" />
    </svg>
);
